module.exports = __webpack_public_path__ + "static/media/bim.db102d34.gif";